export default __webpack_public_path__ + "media/images/logo/media/tv_asahi-a675b791a26178f40c5fcc5d27d6bd6c.png";